import { Component, OnInit } from '@angular/core';
// import androidPhoneBase64 from 'src/assets/base64ImageFiles/androidPhone';
// import iphoneBase64 from 'src/assets/base64ImageFiles/iphoneImg';

@Component({
    selector: 'grading-app',
    templateUrl: './sgc-grading-app.component.html',
    styleUrls: ['./sgc-grading-app.component.scss', './sgc-grading.component.css'],
    standalone: false
})
export class GradingAppComponent implements OnInit {
   appleimg = "/assets/img/blog/play_badges_apple.png";
   googleimg = "/assets/img/blog/play_badges_google.png";
   qrcode = "/assets/img/blog/footerqrcode.png";
//    android = "/assets/img/blog/android-phone-left.png";
//    iphone = "/assets/img/blog/iphone-right.png";
   sgc = "/assets/img/SGC_White-New.png";
   qrcode2 = "../../../../assets/img/blog/footerqrcode.png";
   instagram = "/assets/img/InstagramIcon(inverted).png";
   facebook = "/assets/img/FacebookIcon(inverted).png";
   thread = "/assets/img/thread.png";
   tiktok = "/assets/img/tiktok_icon.png";
   youtube = "/assets/img/youtube_icon.png"

//    android = 'data:image/jpeg;base64,' + androidPhoneBase64;
//    iphone = 'data:image/jpeg;base64,' + iphoneBase64;
    constructor(
    ) { }

    ngOnInit() {
        var userAgent = navigator.userAgent;
        if (userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.href = 'https://apps.apple.com/app/id1625689449';
        } else if (userAgent.match(/Android/i)) {
            window.location.href = 'https://play.google.com/store/apps/details?id=com.sgcgrading';
        }
    }

}
